/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react"
import { message } from "antd"
import { useNavigate } from "react-router-dom"
import bankData from "lib/banks.json"
import { addReapplicant } from "services/ReappLoanService"

const parseStringToInt = (stringValue,defaultValue)=>{
    try {
        const res = parseInt(stringValue,);
        if(isNaN(res)) return defaultValue;
        return res;
    } catch (error) {
        return defaultValue;
    }
}

export function useBankData(){
    const [loadingBanks,setLoadingBanks] = useState(false)
    const [banks,setBanks] = useState([])

    const sortBanks = (bankData)=>{
        if(!bankData){
            return [{ name: "No banks", code: "", id: "hes" }]
        }
        const transformed =  bankData.sort(function (a, b) {
            const nameA = a.name.toUpperCase()
            const nameB = b.name.toUpperCase()
            if (nameA < nameB) return -1 ;
            if (nameA > nameB) return 1 ;
            return 0
        }).map((data)=>({
            ...data,
            label:data.name,
            value:data.code,
        }))

        return transformed
    }

    useEffect(()=>{setBanks(sortBanks(bankData.data))},[])

    return {
        banks,
        loadingBanks,
    }


}
export default function useReapplicantForm(){
    const navigate = useNavigate()
    const [loanAmount, setLoanAmount] = useState("")
    const [loading,setLoading] = useState(false)
    const [disburse_date,setDisburseDate] = useState(new Date())
    const [application_date,setApplicationDate] = useState(new Date())
    const [loan_type,setLoanType] = useState("undergraduate")
    const [loanTenure,setLoanTenure] = useState(12)

    const handleSetLoanAmount = (e)=>{
        setLoanAmount(e.target.value)
    }
    const [applicantData, setApplicantData] = useState({
        name:"",
        first_name:"",
        surname:"",
        lga:"",
        phone:"",
        sex:"",
        age:"",
        dob:"",
        bvn:"",
    })
    const handleSetApplicantData =(e)=>{
        setApplicantData(prev=>({
            ...prev,
            [e.target.name]:e.target.value,
        }))
    }
    const [bankDetails, setBankDetails] = useState({
        bank:"",
        bank_code:"",
        account_number:"",
    })
    const handleSetBankDetails =(e)=>{
        setBankDetails(prev=>({
            ...prev,
            [e.target.name]:e.target.value,
        }))
    }
    const [institutionData, setInstitutionData]= useState({
        name:"",
        course:"",
        current_study_year:"",
        faculty:"",
    })
    const handleSetInstitutiontData =(e)=>{
        setInstitutionData(prev=>({
            ...prev,
            [e.target.name]:e.target.value,
        }))
    }
    const handleSetInstitutionName =(value)=>{
       setInstitutionData(prev=>({
        ...prev,
        name:value,
       }))
    }
    const handleSetFirstGuarantorData =(e)=>{
        setFirstGuarantorData(prev=>({
            ...prev,
            [e.target.name]:e.target.value,
        }))
    }
    const [secondGuarantorData, setSecondGuarantorData] = useState({
        name:"",
        work_place:"",
        phone:"",
    })
    const handleSetSecondGuarantorData =(e)=>{
        setSecondGuarantorData(prev=>({
            ...prev,
            [e.target.name]:e.target.value,
        }))
    }
    const [firstGuarantorData, setFirstGuarantorData] = useState({
        name:"",
        work_place:"",
        phone:"",
    })

    const handleSubmit = async(e)=>{
        e.preventDefault()
        setLoading(true)
        const [_,error] = await addReapplicant({
            institutionData,
            bankDetails,
            loanAmount,
            loanTenure,
            disburse_date,
            application_date,
            monthly_repayment_amount:parseFloat(loanAmount)/parseStringToInt(loanTenure,12),
            applicantData:{
                ...applicantData,
                name:`${applicantData.first_name} ${applicantData.surname}`
            },
            loan_type,
            guarantorDetails:{
                first:firstGuarantorData,
                second:secondGuarantorData,
            }
        })
        setLoading(false)
        if(!error){
            setApplicantData({
                name:"",
                lga:"",
                phone:"",
                sex:"",
                age:"",
            })
            setBankDetails({ bank:"",bank_code:"",account_number:"",})
            setFirstGuarantorData({name:"",work_place:"",phone:"",})
            setInstitutionData({
                name:"",
                course:"",
                current_study_year:"",
                faculty:"",
            })
            setSecondGuarantorData({name:"",work_place:"",phone:"",})
            setLoanAmount("")
            navigate(-1)
            return message.success("Loan Added Successfully")
        }
        return message.error(error.message || "Sorry could not add Loan")
    }

    return {
        applicantData,
        handleSetApplicantData,
        institutionData,
        handleSetInstitutiontData,
        bankDetails,
        handleSetBankDetails,
        firstGuarantorData,
        handleSetFirstGuarantorData,
        secondGuarantorData,
        handleSetSecondGuarantorData,
        loanAmount,
        handleSetLoanAmount,
        loading,
        setBankDetails,
        disburse_date,
        setDisburseDate,
        handleSubmit,
        handleSetInstitutionName,
        loanTenure,
        setLoanTenure,
        loan_type,
        setLoanType,
        application_date,
        setApplicationDate
    }

}